export default "__VITE_ASSET__40a8d213__"